/*
 * Ryan O'Dowd
 * 2025-04-18
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = () => {
  return {
    container: {
      display: 'block',
    },
  };
};

export default getStyles;
